import { useEffect, useState } from 'react';
import { apiFetch } from '@lib/apiClient';

/** One voice note in the Review card, fetched with the bearer (like ReviewPhoto) and played inline. */
export function ReviewVoice({
  campaign,
  recordId,
  index,
}: {
  campaign: string;
  recordId: string;
  index: number;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    (async () => {
      try {
        const res = await apiFetch(
          `/api/intake/review/voice?campaign=${encodeURIComponent(campaign)}&recordId=${encodeURIComponent(
            recordId,
          )}&i=${index}`,
        );
        if (!res.ok) {
          if (!cancelled) setFailed(true);
          return;
        }
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [campaign, recordId, index]);

  if (failed) return <div className="text-xs text-cdx-fg-muted">voice note unavailable</div>;
  if (!url) return <div className="h-8 w-full animate-pulse rounded-cdx bg-cdx-surface-2" />;
  // eslint-disable-next-line jsx-a11y/media-has-caption
  return <audio src={url} controls className="w-full" />;
}
